import React from "react";
import { Link } from "react-router-dom";

/**
 * Mandatory policy consent checkbox (required before pay/submit).
 * Used on /booking/:serviceId (sessions) and /book (digital book).
 *
 * Iteration 98 — sessions must also acknowledge "الشروط والتعليمات" (/terms).
 * Links open in a new tab so the current booking selection is never lost.
 *
 * Props:
 *   checked   – boolean, controlled state from parent
 *   onChange  – (boolean) => void
 *   className – optional extra classes for the wrapper
 *   variant   – "session" (default, includes الشروط والتعليمات) | "book"
 */
const linkCls = "text-[#0A4D3C] underline hover:text-[#063A2D]";

const PolicyLink = ({ to, testId, children }) => (
  <Link
    to={to}
    target="_blank"
    rel="noopener noreferrer"
    onClick={(e) => e.stopPropagation()}
    className={linkCls}
    data-testid={testId}
  >
    {children}
  </Link>
);

const PolicyConsentCheckbox = ({ checked, onChange, className = "", variant = "session" }) => (
  <label
    htmlFor="policy-consent"
    data-testid="policy-consent-wrapper"
    className={`flex items-start gap-3 rounded-2xl border border-[#E5E1D8] bg-[#FAF9F6] p-4 cursor-pointer select-none ${className}`}
  >
    <input
      id="policy-consent"
      type="checkbox"
      checked={!!checked}
      onChange={(e) => onChange(e.target.checked)}
      data-testid="policy-consent-checkbox"
      className="mt-1 w-4 h-4 accent-[#0A4D3C] cursor-pointer shrink-0"
    />
    <span className="text-sm leading-relaxed text-[#222222]" data-testid="policy-consent-text">
      {variant === "session" ? (
        <>
          لقد قرأت وأوافق على{" "}
          <PolicyLink to="/terms" testId="policy-link-instructions">الشروط والتعليمات</PolicyLink>
          ، و<PolicyLink to="/refund-policy" testId="policy-link-refund">سياسة الشراء والاسترجاع</PolicyLink>
          ، و<PolicyLink to="/terms-and-privacy" testId="policy-link-terms">اتفاقية الاستخدام</PolicyLink>
          ، و<PolicyLink to="/privacy-refund" testId="policy-link-privacy">سياسة الخصوصية</PolicyLink>.
        </>
      ) : (
        <>
          لقد قرأت وأوافق على{" "}
          <PolicyLink to="/refund-policy" testId="policy-link-refund">سياسة الشراء والاسترجاع</PolicyLink>{" "}
          و{" "}
          <PolicyLink to="/terms-and-privacy" testId="policy-link-terms">اتفاقية الاستخدام والخصوصية</PolicyLink>
        </>
      )}
    </span>
  </label>
);

export default PolicyConsentCheckbox;
